import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const teamSchema = yup.object().shape({
  name: yup.string().required('required'),
  description: yup.string().required('required'),
  agents: yup.array().required('required'),
});
